import { memo, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingPage from '../../components/LoadingSpinner/LoadingPage';
import { AuthContext } from '../../contexts/AuthContext/AuthContext';

function Auth() {
  const { authenticate, fetchAdminInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    let renewAuth = false;
    if (sessionStorage.getItem('impersonateId')) {
      sessionStorage.removeItem('impersonateId');
      renewAuth = true;
    }
    authenticate().then(() => {
      if (renewAuth) fetchAdminInfo();
      navigate('/');
    });
  }, []);

  return <LoadingPage />;
}

export default memo(Auth);
